import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  GoogleSearchWrapper,
  GoogleSearchInnerWrapper,
  Label,
  SearchInput,
  SubmitButton,
} from './googleSearch.styles';
import { getRelevantLocaleData } from '../../locales/config';
import searchIcon from '../../images/icon-search.svg';

export class GoogleSearch extends PureComponent {
  static propTypes = {
    isPadded: PropTypes.bool,
    handleOnBlur: PropTypes.func,
    inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
  };

  static defaultProps = {
    isPadded: true,
    handleOnBlur: null,
    inputRef: null,
  };

  constructor(props) {
    super(props);
    this.state = { q: '' };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ q: event.target.value });
  }

  render() {
    const searchId = getRelevantLocaleData().googleSearchId;
    const searchLabel = getRelevantLocaleData().googleSearchLabel;
    const searchButtonLabel = getRelevantLocaleData().googleSearchButtonLabel;

    if (!searchId) {
      return null;
    }

    return (
      <GoogleSearchWrapper
        action="https://cse.google.com/cse"
        method="GET"
        isPadded={this.props.isPadded}
      >
        <GoogleSearchInnerWrapper isPadded={this.props.isPadded}>
          <Label htmlFor="gse-search">{searchLabel}</Label>
          <input type="hidden" name="cx" value={searchId} />
          <SearchInput
            id="gse-search"
            type="search"
            name="q"
            value={this.state.value}
            onChange={this.handleChange}
            required
            onBlur={this.props.handleOnBlur}
            ref={this.props.inputRef}
          />
          <SubmitButton type="submit" aria-label={searchButtonLabel}>
            <img
              src={searchIcon}
              loading="lazy"
              height="16"
              width="16"
              alt={searchButtonLabel}
              aria-hidden="true"
            />
          </SubmitButton>
        </GoogleSearchInnerWrapper>
      </GoogleSearchWrapper>
    );
  }
}
